import React, { useEffect, useRef, useState } from "react";
import { Col, Row, Stack } from "react-bootstrap";
import Textarea from "../../../ui/Textarea";
import SelectFamily from "../../../ui/SelectFamily";
import DatePicker from "../../../ui/DatePicker";
import { User } from "../../../../types/user";

interface IntakeState {
  note?: any;
  family: User[];
  setUpdatedNote: any;
  setSaveIsEnabled: any;
  setUserToSave: any;
  myCase?: boolean;
  editNote?: boolean;
}

const Intake = ({ note, family, setUpdatedNote, setSaveIsEnabled, setUserToSave, myCase, editNote = false }: IntakeState) => {
  const mainRef = useRef();
  const [familyUser, setFamilyUser] = useState<string>("unassigned");
  const [noteDate, setNoteDate] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [initialReadOnly, setInitialReadOnly] = useState<boolean>(true);

  const handleScroll = (ref: any) => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    }
  };

  useEffect(() => {
    handleScroll(mainRef);

    if (editNote) {
      setFamilyUser(note?.subject?.id + "|" + note?.subject?.type);
      const isDeleted = family.find((f) => f.id == note?.subject?.id)?.isDeleted;
      if (isDeleted === undefined) {
        setInitialReadOnly(!myCase);
      } else {
        setInitialReadOnly(!myCase || isDeleted);
      }
      setNoteDate(note?.fields?.date);
      setDescription(note?.fields?.description);
    } else {
      setNoteDate(new Date().toISOString().split("T")[0]);
      setInitialReadOnly(!myCase);
    }

    if (family.length === 1) {
      setFamilyUser(family[0].id + "|" + family[0].type);
    }
  }, []);

  useEffect(() => {
    const parts = familyUser.split("|");

    const note = {
      notetype: "intake",
      subject:
        familyUser !== "unassigned"
          ? {
              id: parts[0],
              type: parts[1],
            }
          : { id: 0 },
      fields: {
        date: noteDate,
        description: description,
      },
    };

    setUpdatedNote(note);
  }, [familyUser, noteDate, description, setUpdatedNote]);

  const updateFamilyUser = (e: any) => {
    setFamilyUser(e.target.value);
    if (noteDate) {
      setSaveIsEnabled(true);
      setUserToSave(true);
    }
  };

  const updateDate = () => {
    setSaveIsEnabled(true);
    setUserToSave(true);
  };

  const updateDescription = (e: any) => {
    setDescription(e.target.value);
    if (noteDate) {
      setSaveIsEnabled(true);
      setUserToSave(true);
    }
  };

  useEffect(() => {
    if (!noteDate) {
      setSaveIsEnabled(false);
      setUserToSave(false);
    }
  }, [noteDate]);

  return (
    <Stack gap={3} className="mt-4">
      <Row ref={mainRef}>
        <SelectFamily
          family={family}
          familyUser={familyUser}
          updateFamilyUser={updateFamilyUser}
          readOnly={initialReadOnly}
          defaultSelection="Unassigned"
        />
        <Col className="col-lg-4 col-md-6 col-sm-8">
          <DatePicker
            label="Date"
            currentValue={noteDate}
            setCurrentValue={setNoteDate}
            onUpdate={() => updateDate()}
            required={true}
            hasMaxDate={true}
            disabled={myCase ? false : true}
          />
        </Col>
      </Row>
      <Row className="mb-5">
        <Col xs={12}>
          <Textarea label="Description" value={description} onUpdate={(e: any) => updateDescription(e)} disabled={myCase ? false : true} />
        </Col>
      </Row>
    </Stack>
  );
};

export default Intake;
